import { render } from "./EditTournamentDetails.vue?vue&type=template&id=a11a29c2&scoped=true"
import script from "./EditTournamentDetails.vue?vue&type=script&lang=js"
export * from "./EditTournamentDetails.vue?vue&type=script&lang=js"

import "./EditTournamentDetails.vue?vue&type=style&index=0&id=a11a29c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11a29c2"]])

export default __exports__